import React from 'react'
import classnames from 'classnames'

import Fancybox from '../Fancybox/Fancybox'

import ZoomIcon from '../../images/zoom.inline.svg'
import { container, gallery, desc, zoom } from './Gallery.module.scss'

const Gallery = ({ size, description, images, className }) => {
  const galleryId = images[0].id

  return (
    <div className={classnames(container, size, className)}>
      <Fancybox>
        <ul className={classnames(gallery)}>
          {images.map((image) => {
            const imgUrl = image.mediaDetails.sizes.filter(
              (size) => size.name === 'medium'
            )[0].sourceUrl

            return (
              <li key={image.id}>
                <a
                  href={image.sourceUrl}
                  data-fancybox={galleryId}
                  data-src={image.sourceUrl}
                  className={size}
                >
                  <img
                    src={imgUrl}
                    srcSet={image.srcSet}
                    alt={image.altText}
                    loading={'lazy'}
                  />
                  <span className={classnames(zoom)}>
                    <ZoomIcon with={32} height={32} />
                  </span>
                </a>
              </li>
            )
          })}
        </ul>
      </Fancybox>
      {description && <div className={desc}>{description}</div>}
    </div>
  )
}

export default Gallery
